/**
 * The spoonfed how-to for the invitation import (FUS-927 CSM ask): the
 * HubSpot export path and the fill-in template path, step by step.
 */
function InvitationCreateImportHelp() {
  return (
    <div className="flex flex-col gap-3 rounded-md bg-muted/50 p-3 text-xs text-muted-foreground">
      <div>
        <span className="font-medium text-foreground">From HubSpot</span>
        <ol className="mt-1 list-decimal space-y-0.5 pl-4">
          <li>
            In HubSpot, open Contacts and select the view or list you want to
            invite (e.g. everyone at one company).
          </li>
          <li>
            Choose Export, pick Excel or CSV, and download the file when HubSpot
            emails it.
          </li>
          <li>
            Drop the file here (or open it, copy the rows with the header row,
            and paste below).
          </li>
          <li>
            The company column becomes the team: existing teams match
            automatically, and a new team with a matching customer name is one
            click to create.
          </li>
        </ol>
      </div>
      <div>
        <span className="font-medium text-foreground">From the template</span>
        <ol className="mt-1 list-decimal space-y-0.5 pl-4">
          <li>Download the template and fill in one row per person.</li>
          <li>Replace the example row — it is not sent, but tidy up.</li>
          <li>Drop the saved file here, or copy-paste the rows.</li>
        </ol>
      </div>
      <span>
        Anything tab, semicolon or comma separated works. Nothing is sent until
        you review the board and press send.
      </span>
    </div>
  )
}

export default InvitationCreateImportHelp
